var map = {
	"./jw_black.jpg": 743,
	"./jw_double_black.jpg": 744,
	"./jw_gold.jpg": 745,
	"./jw_green.jpg": 746,
	"./jw_platinum.jpg": 747,
	"./jw_red.jpg": 748
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 742;


//////////////////
// WEBPACK FOOTER
// ./src/imgs/bottles/backgrounds/Templates/Backgrounds nonrecursive \.(jpg)$
// module id = 742
// module chunks = 0